/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");


require('components/base/input-box/input-box');
require('components/base/checkbox/checkbox');
require('components/base/form-area/form-area');
require('components/base/drop-menu/drop-menu');
require('components/base/upload/upload')
require('components/common/drop-menu-input/drop-menu-input')
require('components/common/date-time/date-time')
require('./add.scss');
require('components/base/pop/pop');

const E = require('wangeditor')
const EDITOR = new E('#editor')

const tip = require('components/base/pop/tip');
const template = require('./add.tpl');
const ajaxHttp = require('appUtil/ajaxHttp.js');
const configPushMixin = require('../../mixin')

const { apiPath } = require('appService/api');
const { dropMenu: dropMenuEvent, checkbox: checkboxEvent, dateTime: dateTimeEvent } = require('components/config/event.json');

const addHalfPageAd = {
  name: "add-ad-config",

  template,

  mixins: [configPushMixin],

  data() {
    return {
      uploadImg: apiPath.common.uploadImg,
      detailData: {
        platform: 1,
        redirectType: 1,
        content: ''
      },
      linkInputReadOnly: false,
      cityOptionUrl: apiPath.common.city,
      linkInputEmpty: true,
      tagList: [],
      platform: 0,
      okBtnName: '确定',
      limit: false,
      editor:null,
      redirectType: 1
    }
  },

  computed: {
    isEdit () {
      return !!this.$route.params.id
    },
    isDetail () {
      return !!this.$route.params.flag
    }
  },

  events: {
    [dropMenuEvent.menu.change](opt) {
      if (opt.dispatcher.queryName === 'adType') {
        if (opt.value === 2 || opt.value === 3) {
          this.linkInputEmpty = false
        } else {
          this.linkInputEmpty = true
        }
      }

      return false;
    },
    [checkboxEvent.change](val) {
      if (val.queryName === 'platform') {
        let {value} = val
        this.platform = value
        return false
        
      }

      if (val.queryName === 'redirectType') {
        let {value} = val
        this.redirectType = value
        return false
        
      }

      if (val.queryName === 'launchTag') {
        let {value} = val

        return false
      }
    }
  },

  methods: {
    _init(){
      if(this.isEdit) {
        // 编辑状态
        ajaxHttp(apiPath.configPush.halfPageAd.detail, {
          data: {
            id: this.$route.params.id
          }
        }).then((rtn) => {
          this.detailData = rtn.data

          let {launchTag, launchCity, redirectType, content} = rtn.data
          this.detailData.platform = 1
          if (launchTag) {
            this.platform = 2
            this.detailData.platform = 2
            this.detailData.launchTag = launchTag.split(',')
          }
          
          if (launchCity && launchCity.length > 0 && !!launchCity[0]) {
            this.platform = 3
            this.detailData.platform = 3
          }

          if (redirectType) {
            this.redirectType = redirectType
            if (redirectType == 2) {
              this.detailData.content = content
              EDITOR.txt.html(content || '')
            }
          }


        }).catch((rtn) => {
          tip(rtn.message)
        })
      }
    },

    loadTag() {
      ajaxHttp(apiPath.configPush.adConfig.tagList, {
        data: {
          _index: 1,
          _size: 100
        }
      }).then((rtn) => {
        let {records} = rtn.data
        let arr = []
        records.map(item => {
          let {name, id} = item
          arr.push({
            text: name,
            value: id
          })
        })

        this.tagList = arr
      }).catch((rtn) => {
        tip(rtn.message)
      })
    },

    submit () {
      var $refs = this.$refs

      if (this.isEdit) {
        $refs.formArea.setAction(apiPath.configPush.adConfig.edit).submit()
      } else {
        $refs.formArea.setAction(apiPath.configPush.adConfig.add).submit()
      }
    },

    beforeSubmit (queryOpt, vm) {

      let {launchCity, platform, launchTag, redirectType} = queryOpt
     
      if (platform === 2) {
        vm.queryOpt.launchTag = launchTag.join(',')
      }
      
      if (platform == 3) {
        vm.queryOpt.launchCity = launchCity.join(',')
      }
      this.$refs.submit.switchBtnLoading('show')
    },

    submitSuccess (rtn) {
      const self = this

      if (rtn.code === 0) {
        tip(`${this.isEdit ? '保存' : '新增'}成功`, {
          cb() {
            self.$route.router.go({
              path: '/page/configPush/adConfig'
            })
          }
        })
      } else {
        tip (rtn.error)
      }

      this.$refs.submit.switchBtnLoading('hide')
    },
    addTagSuccess(rtn) {
      if (rtn.code === 0) {
        tip(`新增成功`, {
          cb: ()=> {
            this.cancel()
            this.loadTag()
          }
        })
      } else {
        tip (rtn.error)
      }
     
      this.$refs.submitTag.switchBtnLoading('hide')
    },
    beforeTagSubmit(queryOpt, vm) {
      this.$refs.submitTag.switchBtnLoading('show')
    },
    submitTag() {
      this.$refs.formAreaTag.setAction(apiPath.configPush.adConfig.tagAdd).submit()
    },
    cancel() {
      this.$refs.tagAdd.hide()
    },
    addTagPop() {
      this.$refs.tagAdd.show()
    },
    removeTag() {
      this.$refs.tagRemove.show()
    },
    confirmRemove() {
      if (this.limit) {
        return false
      }
      this.limit = true
      this.okBtnName = '正在删除...'
      ajaxHttp(apiPath.configPush.adConfig.tagRemove, {
        type: 'POST',
        data: {
          id: this.$refs.tagListDom.value
        }
      }).then((rtn) => {
        this.limit = false
        tip('删除成功')
        this.loadTag()
        this.$refs.tagRemove.hide()
        this.okBtnName = '确定'
      }).catch((rtn) => {
        this.limit = false
        tip(rtn.message)
        this.okBtnName = '确定'
      })
    },
    initEditor() {
      EDITOR .customConfig.zIndex = 10
      EDITOR.customConfig.onchange =  (html) => {
        // html 即变化之后的内容
        console.log(html)

        this.detailData.content = html
      }
      EDITOR.create()
    },
    updateTime(val) {
      console.log(val)
    }
  },

  ready(){
    this._init()
    this.loadTag()
    this.initEditor()
    // console.log(wangeditor)
  }
}

module.exports = addHalfPageAd;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/ad-config/add/add.js